import { API_CONVEYANCE_TYPES } from './events';
import { type IUserInfo } from '@/types/checkout';

const privacyUrl = 'https://chowly.com/diner-privacy-policy/';
const termsUrl = 'https://chowly.com/diner-terms-and-conditions/';
export const LINKS_MAP: Record<string, string> = {
  'privacy policy': privacyUrl,
  'terms & conditions': termsUrl,
  privacy: privacyUrl,
  terms: termsUrl,
};

// TODO - deprecate
export const API_FOR_CONVEYANCE_TYPES_SWAP = {
  pick_up: 'Pickup',
  delivery: 'Delivery',
  curbside: 'Curbside',
  dine_in: 'Dine-In',
  drive_thru: 'Drive-Thru',
  drive_in: 'Drive-In',
} as const;

export const LOCKED_FLOW_CONVEYANCE_TYPES = [API_CONVEYANCE_TYPES.DINEIN];

export const ASAP = 'asap';
export const SCHEDULED = 'scheduled';
export const ASAP_VALUE = '';

export const TIME_MODES = {
  ASAP,
  SCHEDULED,
} as const;

// Remove
export const DELIVERY_TIME_WANTED_MODES = {
  ASAP: 'asap',
  ADVANCE: 'advance',
} as const;

export type DeliveryModes = 'asap' | 'advance';

export const ALLERGEN_CARD_MODE = {
  DETAIL: 'detail',
  MENU: 'menu',
  OPTIONS: 'options',
} as const;

export const ALLERGEN_TAG_LOCATIONS = {
  MENU_ITEM: 'menu-item',
  ITEM_DETAIL: 'item-detail',
  ITEM_OPTION_IMAGE: 'item-option-image',
  ITEM_OPTION_NO_IMAGE: 'item-option-no-image',
  CART: 'cart',
};

export const ERROR_DISPLAY_DURATION = {
  FIVE: 5000,
};

export const TIMESLOT_TYPES = {
  BASKET_TIMES: 'basketTimes',
  LOCATION_TIMES: 'locationTimes',
};

export const MAX_LENGTH = {
  DELIVERY_INSTRUCTIONS: 128,
  ITEM_RECIPIENT: 32,
};

export enum GOOGLE_LIBRARIES {
  PLACES = 'places',
  MARKER = 'marker',
}

export const ALLOWED_URL_PARAMETER_KEYS = {
  HANDOFF: 'handoff',
  TABLE_NUMBER: 'table_number',
};

export const ALLOWED_URL_PARAMETER_VALUES = {
  [ALLOWED_URL_PARAMETER_KEYS.HANDOFF]: ['dine_in'],
  [ALLOWED_URL_PARAMETER_KEYS.TABLE_NUMBER]: [],
};

export enum KOALA_SESSION_STORAGE_KEYS {
  METADATA = 'koalaMetadata',
  PARAMETERS = 'koalaRouteParameters',
  /** Base key (suffixed with the store id) tracking whether the POS-unavailable modal has been shown this session. */
  POS_UNAVAILABLE_MODAL_SEEN = 'posUnavailableModalSeen',
  /** Basket + handoff type the automatic default tip has been settled for (TEAM-14667). */
  DEFAULT_TIP_SETTLED_SCOPE = 'defaultTipSettledScope',
}

/**
 * Next v12 changed the default cache policy for server-rendered pages to
 * `no-cache, no-store, max-age=0, must-revalidate`, effectively disabling
 * all server-side caching. Since web-ordering currently doesn't support
 * server-side auth, we can set a pretty aggressive cache policy.
 * @see https://nextjs.org/docs/going-to-production#caching
 */
export const DEFAULT_SSR_CACHE_POLICY = 'public, max-age=86400';

/**
 * Tells the edge cache on the POPs (`cache_middle`, Chowly/terraform `apps/go/caddy_cache`) not
 * to keep a response. The POP removes the header before the response reaches the diner and sends
 * `Cache-Control: no-store` in its place. `Cache-Control` itself can't carry this: the POP strips
 * the app's own on custom domains and ignores it everywhere. The store page sends it when it
 * renders no menu products, so a page built while the restaurant is closed is never served after
 * it opens, and for an inactive location or one not found, so neither outlives its cause.
 * (TEAM-16180)
 */
export const EDGE_NO_STORE_HEADER = { name: 'Surrogate-Control', value: 'no-store' } as const;

export const SMB_DRIVER_ID = 7;

export const PRODUCTION_HEAP_ID = '3745098455';

export const STAGING_HEAP_ID = '3177339425';

export enum REQUEST_STATUS {
  LOADING = 'pending',
  SUCCESS = 'success',
  ERROR = 'error',
  IDLE = 'idle',
}

export const ONE_MINUTE_IN_MILLISECONDS = 60000;

export const DEFAULT_GUEST_USER = {
  first_name: 'Default',
  last_name: 'Chowly',
  email: 'example@chowlyinc.com',
  phone: '2018554940',
};

export const NO_USER: IUserInfo = {
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
};
